import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Gemeinde extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    bezeichnung: string | null = null;
    bfs_nummer: number | null = null;
    kanton_id: number | null = null;

    // view fields:
    kanton: string | null = null;
    kanton_kuerzel: string | null = null;
    mandant: boolean | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Gemeinde';
    }
}

export async function createNewGemeinde(): Promise<Gemeinde> {
    const gemeinde = createModel(Gemeinde, {});

    await gemeinde.save();
    return gemeinde;
}

export class GemeindeCollection extends BaseCollection<Gemeinde> {
    protected modelCls = Gemeinde;

    public getModelClassName(): string {
        return 'Gemeinde';
    }
}
